module.exports = __webpack_public_path__ + "static/media/arrowdown.1a6f832f.svg";